import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { verifyAdmin, getToken } from './adminApi';

export default function AdminProtected({ children }) {
  const location = useLocation();
  const [state, setState] = useState({ loading: true, ok: false });

  useEffect(() => {
    if (!getToken()) { setState({ loading: false, ok: false }); return; }
    verifyAdmin().then((ok) => setState({ loading: false, ok }));
  }, []);

  if (state.loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f4f5f7]">
        <div className="animate-pulse text-[#58677A]/60 text-sm">Verificando sesión…</div>
      </div>
    );
  }
  if (!state.ok) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}
